import type { ReactNode } from 'react'
import styles from '@/pages/Admin/Admin.module.css'

interface AdminPanelProps {
  title?: ReactNode
  description?: string
  children: ReactNode
  footer?: ReactNode
}

export function AdminPanel({ title, description, children, footer }: AdminPanelProps) {
  return (
    <section className={styles.panel}>
      {(title || description) && (
        <div className={styles.panelHead}>
          {title && <h2 className={styles.panelTitle}>{title}</h2>}
          {description && <p className={styles.panelDesc}>{description}</p>}
        </div>
      )}
      <div className={styles.panelBody}>{children}</div>
      {footer && <div className={styles.panelFooter}>{footer}</div>}
    </section>
  )
}
